const MONTHS = [
    { label: 'январь', value: 1 },
    { label: 'февраль', value: 2 },
    { label: 'март', value: 3 },
    { label: 'апрель', value: 4 },
    { label: 'май', value: 5 },
    { label: 'июнь', value: 6 },
    { label: 'июль', value: 7 },
    { label: 'август', value: 8 },
    { label: 'сентябрь', value: 9 },
    { label: 'октябрь', value: 10 },
    { label: 'ноябрь', value: 11 },
    { label: 'декабрь', value: 12 },
];

const YEARS = (() => {
    const from = 1961;
    const to = new Date().getFullYear();

    return Array.from({ length: to - from + 1 }, (_, i) => {
        const y = to - i;
        return { label: String(y), value: y };
    });
})();

const openDropdowns = new Set();

const PICKERS = {
    'date-start': { month: null, year: null },
    'date-end': { month: null, year: null },
};

function getCurrentMonthYear() {
    const now = new Date();

    return {
        month: now.getMonth() + 1,
        year: now.getFullYear(),
    };
}

function isFutureMonthYear(month, year) {
    if (month == null || year == null) {
        return false;
    }

    const current = getCurrentMonthYear();

    return year > current.year || (year === current.year && month > current.month);
}

function closeAllDropdowns(except = null) {
    openDropdowns.forEach(dd => {
        if (dd !== except) dd.classList.add('hidden');
    });

    if (!except) openDropdowns.clear();
}

function resetPickerToAll(prefix) {
    PICKERS[prefix].year.setOptions(YEARS);
    PICKERS[prefix].month.setOptions(MONTHS);

    PICKERS[prefix].year.close?.();
    PICKERS[prefix].month.close?.();
}

function attachDropdown({ wrapperEl, uiInputEl, clearBtnEl, hiddenInputEl, options, onSelect }) {
    const dropDown = document.createElement('div');
    dropDown.className =
        'absolute left-0 right-0 mt-2 py-4 max-h-80 overflow-auto rounded-[24px] bg-background-body_secondary z-50 hidden';
    wrapperEl.appendChild(dropDown);

    function render(opts) {
        dropDown.innerHTML = opts
            .map(
                o =>
                    `<button type="button" class="text-left w-full p-3 title-4-bold hover:bg-white_overlay" data-value="${o.value}">${o.label}</button>`
            )
            .join('');
    }
    render(options);

    dropDown.addEventListener('click', e => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;

        uiInputEl.value = btn.textContent.trim();
        hiddenInputEl.value = String(btn.getAttribute('data-value'));
        clearBtnEl.classList.remove('hidden');
        dropDown.classList.add('hidden');

        onSelect();
        e.stopPropagation();
    });

    uiInputEl.addEventListener('click', e => {
        e.stopPropagation();

        const willOpen = dropDown.classList.contains('hidden');

        if (willOpen) {
            closeAllDropdowns(dropDown);

            dropDown.classList.remove('hidden');
            openDropdowns.add(dropDown);
        } else {
            dropDown.classList.add('hidden');
            openDropdowns.delete(dropDown);
        }
    });

    clearBtnEl.addEventListener('click', e => {
        e.stopPropagation();

        uiInputEl.value = '';
        hiddenInputEl.value = '';
        clearBtnEl.classList.add('hidden');
        dropDown.classList.add('hidden');

        onSelect();
    });

    wrapperEl.addEventListener('click', e => e.stopPropagation());

    return {
        setOptions(newOptions) {
            render(newOptions);

            const cur = hiddenInputEl.value ? Number(hiddenInputEl.value) : null;

            if (cur != null && !newOptions.some(o => o.value === cur)) {
                uiInputEl.value = '';
                hiddenInputEl.value = '';
                clearBtnEl.classList.add('hidden');
            }
        },
        getValue() {
            return hiddenInputEl.value === '' ? null : Number(hiddenInputEl.value);
        },
        clear() {
            uiInputEl.value = '';
            hiddenInputEl.value = '';
            clearBtnEl.classList.add('hidden');
        },
        close() {
            dropDown.classList.add('hidden');
            openDropdowns.delete(dropDown);
        },
    };
}

function recomputeConstraints() {
    const current = getCurrentMonthYear();
    const startYear = PICKERS['date-start'].year.getValue();
    const endYear = PICKERS['date-end'].year.getValue();
    const startMonth = PICKERS['date-start'].month.getValue();
    const endMonth = PICKERS['date-end'].month.getValue();

    const startYearOptions = YEARS.filter(y => y.value <= current.year && (endYear == null ? true : y.value <= endYear));
    const endYearOptions = YEARS.filter(y => y.value <= current.year && (startYear == null ? true : y.value >= startYear));

    PICKERS['date-start'].year.setOptions(startYearOptions);
    PICKERS['date-end'].year.setOptions(endYearOptions);

    const startMonthOptions =
        startYear == null || endYear == null || startYear < endYear
            ? startYear == null || startYear < current.year
                ? MONTHS
                : MONTHS.filter(m => m.value <= current.month)
            : MONTHS.filter(m => (endMonth == null ? true : m.value <= endMonth));

    const constrainedStartMonthOptions =
        startYear == null || startYear < current.year
            ? startMonthOptions
            : startMonthOptions.filter(m => m.value <= current.month);

    const endMonthOptions =
        startYear == null || endYear == null || startYear < endYear
            ? endYear == null || endYear < current.year
                ? MONTHS
                : MONTHS.filter(m => m.value <= current.month)
            : MONTHS.filter(m => (startMonth == null ? true : m.value >= startMonth));

    const constrainedEndMonthOptions =
        endYear == null || endYear < current.year
            ? endMonthOptions
            : endMonthOptions.filter(m => m.value <= current.month);

    PICKERS['date-start'].month.setOptions(constrainedStartMonthOptions);
    PICKERS['date-end'].month.setOptions(constrainedEndMonthOptions);
}

function setupMonthYearPicker(prefix, onChange) {
    const monthUI = document.getElementById(`${prefix}-month-input`);
    const yearUI = document.getElementById(`${prefix}-year-input`);
    const monthClear = document.getElementById(`${prefix}-month-clear`);
    const yearClear = document.getElementById(`${prefix}-year-clear`);
    const monthHidden = document.getElementById(`${prefix}-month`);
    const yearHidden = document.getElementById(`${prefix}-year`);
    const monthWrapper = document.getElementById(`${prefix}-month-wrapper`);
    const yearWrapper = document.getElementById(`${prefix}-year-wrapper`);

    PICKERS[prefix].month = attachDropdown({
        wrapperEl: monthWrapper,
        uiInputEl: monthUI,
        clearBtnEl: monthClear,
        hiddenInputEl: monthHidden,
        options: MONTHS,
        onSelect: () => {
            recomputeConstraints();
            onChange();

            if (monthHidden.value) {
                const companyIdInput = document.getElementById('company-id-input').value || '-1';
                if (window.isOnboarding && prefix === 'date-start') {
                    if (window.sendAnalytics) {
                        window.sendAnalytics({
                            event_name: 'onboarding_worktime_start_time',
                            event_category: 'onboarding',
                            event_action: 'worktime',
                            event_label: 'start_time_chosen',
                            event_params: {
                                company_id: companyIdInput,
                                company_name: window.workExperienceManager.selectedCompanyName,
                            },
                        });
                    } else {
                        window.captureError(
                            new Error(
                                'window.sendAnalytics is not defined, skipping event onboarding_worktime_start_time'
                            ),
                            { page: 'Onboarding work exp date' }
                        );
                    }
                }

                if (window.isOnboarding && prefix === 'date-end') {
                    if (window.sendAnalytics) {
                        window.sendAnalytics({
                            event_name: 'onboarding_worktime_end_time',
                            event_category: 'onboarding',
                            event_action: 'worktime',
                            event_label: 'end_time_chosen',
                            event_params: {
                                company_id: companyIdInput,
                                company_name: window.workExperienceManager.selectedCompanyName,
                            },
                        });
                    } else {
                        window.captureError(
                            new Error(
                                'window.sendAnalytics is not defined, skipping event onboarding_worktime_end_time'
                            ),
                            { page: 'Onboarding work exp date' }
                        );
                    }
                }
            }
        },
    });

    PICKERS[prefix].year = attachDropdown({
        wrapperEl: yearWrapper,
        uiInputEl: yearUI,
        clearBtnEl: yearClear,
        hiddenInputEl: yearHidden,
        options: YEARS,
        onSelect: () => {
            recomputeConstraints();
            onChange();

            if (yearHidden.value) {
                const companyIdInput = document.getElementById('company-id-input').value || '-1';
                if (window.isOnboarding && prefix === 'date-start') {
                    if (window.sendAnalytics) {
                        window.sendAnalytics({
                            event_name: 'onboarding_worktime_start_time',
                            event_category: 'onboarding',
                            event_action: 'worktime',
                            event_label: 'start_time_chosen',
                            event_params: {
                                company_id: companyIdInput,
                                company_name: window.workExperienceManager.selectedCompanyName,
                            },
                        });
                    } else {
                        window.captureError(
                            new Error(
                                'window.sendAnalytics is not defined, skipping event onboarding_worktime_start_time'
                            ),
                            { page: 'Onboarding work exp date' }
                        );
                    }
                }

                if (window.isOnboarding && prefix === 'date-end') {
                    if (window.sendAnalytics) {
                        window.sendAnalytics({
                            event_name: 'onboarding_worktime_end_time',
                            event_category: 'onboarding',
                            event_action: 'worktime',
                            event_label: 'end_time_chosen',
                            event_params: {
                                company_id: companyIdInput,
                                company_name: window.workExperienceManager.selectedCompanyName,
                            },
                        });
                    } else {
                        window.captureError(
                            new Error(
                                'window.sendAnalytics is not defined, skipping event onboarding_worktime_end_time'
                            ),
                            { page: 'Onboarding work exp date' }
                        );
                    }
                }
            }
        },
    });
}

function setupWorkingNowToggleHandling() {
    const dateWorkingNowBlock = document.getElementById('date-working-now');
    const dateWorkingNowToggle = document.getElementById('date-working-now-toggle');
    const dateWorkingNowKnob = document.getElementById('date-working-now-knob');

    if (!dateWorkingNowBlock || !dateWorkingNowToggle || !dateWorkingNowKnob) {
        return;
    }

    const dateEndYearInput = document.getElementById('date-end-year');
    const dateEndMonthInput = document.getElementById('date-end-month');

    const dateEndBlock = document.querySelector('#date-end > div');
    const dateEndYearUIInput = document.getElementById('date-end-year-input');
    const dateEndMonthUIInput = document.getElementById('date-end-month-input');

    const dateEndYearClear = document.getElementById('date-end-year-clear');
    const dateEndMonthClear = document.getElementById('date-end-month-clear');

    if (dateWorkingNowBlock._workingNowHandler) {
        dateWorkingNowBlock.removeEventListener('click', dateWorkingNowBlock._workingNowHandler);
    }

    const handler = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const workCurrentlyInput = document.getElementById('work-currently');
        if (!workCurrentlyInput) return;

        const newValue = workCurrentlyInput.value === 'true' ? 'false' : 'true';
        workCurrentlyInput.value = newValue;

        dateWorkingNowToggle.classList.toggle('bg-background-tertiary');
        dateWorkingNowToggle.classList.toggle('bg-background-accent_secondary');

        dateWorkingNowKnob.classList.toggle('translate-x-5');
        dateWorkingNowKnob.classList.toggle('translate-x-0');

        if (newValue === 'true') {
            if (dateEndBlock) dateEndBlock.classList.add('hidden');
            if (dateEndYearClear) dateEndYearClear.classList.add('hidden');
            if (dateEndMonthClear) dateEndMonthClear.classList.add('hidden');
            if (dateEndYearUIInput) dateEndYearUIInput.value = '';
            if (dateEndMonthUIInput) dateEndMonthUIInput.value = '';
            if (dateEndYearInput) dateEndYearInput.value = '';
            if (dateEndMonthInput) dateEndMonthInput.value = '';

            const startYearInput = document.getElementById('date-start-year');
            const startMonthInput = document.getElementById('date-start-month');
            const startYearEmpty = !startYearInput?.value;
            const startMonthEmpty = !startMonthInput?.value;
            if (startYearEmpty && startMonthEmpty) {
                resetPickerToAll('date-start');
            }
        } else if (dateEndBlock) {
            dateEndBlock.classList.remove('hidden');
        }

        recomputeConstraints();
        validateDatesFormInput();

        if (window.isOnboarding && newValue === 'true') {
            const companyIdInput = document.getElementById('company-id-input');
            const companyId = companyIdInput?.value || '-1';

            if (window.sendAnalytics) {
                window.sendAnalytics({
                    event_name: 'onboarding_worktime_still_here',
                    event_category: 'onboarding',
                    event_action: 'worktime',
                    event_label: 'still_here',
                    event_params: {
                        company_id: companyId,
                        company_name: window.workExperienceManager?.selectedCompanyName,
                    },
                });
            } else {
                window.captureError(
                    new Error('window.sendAnalytics is not defined, skipping event onboarding_worktime_still_here'),
                    { page: 'Onboarding work exp date' }
                );
            }
        }
    };

    dateWorkingNowBlock.addEventListener('click', handler);
    dateWorkingNowBlock._workingNowHandler = handler;
}

function validateDatesFormInput() {
    const isEditForm = document.getElementById('work-experience-edit-form');

    if (isEditForm) {
        window.workExperienceManager.validateEditFormInput();
    } else {
        const nextFooterButton = document.querySelector('.next-footer-button');
        const enabled = window.workExperienceManager.isDateValid();

        if (enabled) {
            nextFooterButton.classList.remove('pointer-events-none');
            nextFooterButton.classList.remove('bg-component-button-background-secondary');
            nextFooterButton.classList.remove('text-text-tertiary');
            nextFooterButton.classList.add('bg-brand_gradient_button');
        } else {
            nextFooterButton.classList.add('pointer-events-none');
            nextFooterButton.classList.add('bg-component-button-background-secondary');
            nextFooterButton.classList.add('text-text-tertiary');
            nextFooterButton.classList.remove('bg-brand_gradient_button');
        }
    }
}

function initializeDateHandlers() {
    setupWorkingNowToggleHandling();
    setupMonthYearPicker('date-start', validateDatesFormInput);
    setupMonthYearPicker('date-end', validateDatesFormInput);

    recomputeConstraints();
}

document.addEventListener('DOMContentLoaded', function () {
    initializeDateHandlers();

    document.addEventListener('click', () => closeAllDropdowns());
    window.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });
});

document.addEventListener('htmx:afterSwap', function (e) {
    if (e.detail.target.querySelector('#date-working-now') || e.detail.target.id === 'date-working-now') {
        initializeDateHandlers();
    }
});

window.workExperienceDateUtils = {
    isFutureMonthYear,
};
